import Fuse from 'fuse.js';
import {makeAutoObservable} from 'mobx';

import {i18n} from '@yourcoach/i18n';

import type {TextInput} from '../../../uikit/TextInput';
import type {Country} from '../../../utils/countries';
import type {GetComponentProps} from '../../../utils/utility-types';

import {getCountries} from '../../../utils/countries';

export class SelectCountryStore {
  private readonly countriesProvider = getCountries();
  countries = this.countriesProvider.countries.slice();
  private readonly fuse = new Fuse(this.countries, {
    keys: ['dialCode', 'name', 'iso2'],
    threshold: 0.3,
  });

  constructor() {
    makeAutoObservable(this, {}, {autoBind: true});
  }

  get searchPlaceholder() {
    return i18n.t('shared:search');
  }

  get title() {
    return i18n.t('shared:SelectCountry.title');
  }

  keyExtractor(country: Country) {
    return country.iso2;
  }

  onSearchQueryChange(
    e: Parameters<GetComponentProps<typeof TextInput>['onChange']>[0],
  ) {
    const query = e.payload?.text || '';

    let result = this.countriesProvider.countries.slice();

    if (/\d/.test(query)) {
      const iso2Arr =
        Object.keys(this.countriesProvider.countryDialCodeLookup)
          .filter(key => key === query)
          .map(key => this.countriesProvider.countryDialCodeLookup[key])[0] ||
        [];

      result = iso2Arr.map(
        iso2 => this.countriesProvider.countryIso2Lookup[iso2]!,
      );
    } else if (query) {
      result = this.fuse.search(query).map(item => item.item);
    }

    this.countries = result;
  }
}
